<template>
	<div class="tabs">
		<div class="tabs-header">
			<h3 :class="[currentTab === 0 && 'selected']" @click="() => currentTab = 0">DESCRIÇÃO DO OBJETO</h3>

			<h3 :class="[currentTab === index+1 && 'selected']" v-for="(tab, index) in tabs" :key="index" @click="() => currentTab = index + 1" >
				{{ tabs[index].nome }}
			</h3>
			<!-- <h3 :class="[currentTab === 2 && 'selected']" @click="() => currentTab = 2">DIREITO AUTORAIS</h3> -->
		</div>
		<div class="tab-content">
			<div class="descricao" v-if="currentTab === 0">
				<div v-html="objeto.descricao"></div>
			</div>

			<div class="ficha" v-for="(tab, index) in tabs" :key="index" >
				<ul v-if="currentTab === index + 1">
					<li v-for="item in tab.texto.split('|~|')" :key="item">
						{{ item }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Tabs',
	props: {
		objeto: {
			type: Object,
			required: true
		},
		tabs: {
			type: Array
		}
	},
	data () {
		return {
			currentTab: 0,
			object: this.objeto
		}
	},
	methods: {
		dateFormat (date) {
			if (!(date instanceof Date)) {
				date = new Date(date)
			}

			const d = date.getDate().toString().padStart(2, '0')
			const m = (date.getMonth() + 1).toString().padStart(2, '0')
			const y = date.getFullYear().toString().padStart(4, '0')

			return `${d}/${m}/${y}`
		},
		getValor () {
			console.log('ffxvcv', this.object)
		}
	},
	mounted () {
		this.getValor()
		// this.getValor()
		// object.objeto = ['this', 'objeto']
		// console.log('xvcv', this.objeto[1].type)
		// this.$nextTick(function () {
		// 	console.log(this.objeto)
		// })
	}
}
</script>

<style lang="scss" scoped>
.tabs {
	margin: 84px 0;
	color: #fff;
	border-bottom: 1px solid #fff;

	.tabs-header {
		display: flex;
		justify-content: center;
		align-items: center;
		border-bottom: 1px solid #fff;

		h3 {
			font-size: 1.2em;
			font-weight: 700;
			margin: 0 40px;
			cursor: pointer;
			height: 50px;
			transition: .3s ease;

			&:focus {
				border-bottom: 4px solid #fff;
			}

			&:hover {
				border-bottom: 4px solid #fff;
			}

			&.selected {
				border-bottom: 4px solid #fff;
			}
		}
	}

	.tab-content {
		padding: 30px 0;

		.ficha {
			p {
				padding: 8px 0;
				border-bottom: 1px solid #CCC1;

				b {
					display: inline-block;
					width: 200px;
					font-weight: bold;
				}

				.data {
					display: inline-block;
					margin-left: 30px;
				}
			}
		}
	}
}
</style>
